import Vue from 'vue';
import store from './../../store';

const success = (context, response) => {
  context.user = response.data.user;
  if (context.changePaymentCard) {
    // context.deleteOldCard();
    toastr.success(context.$t('account.settings.credit_card.card_changed_success'));
  } else {
    toastr.success(context.$t('account.settings.credit_card.card_created_success'));
  }
  store.dispatch('updateAccount', context.user);

  context.closeModal('#change-card-modal');

  context.loading = false;
};

const failed = (error, context) => {
  context.showToasterError(error);
};

export default (context, data) => Vue.$http.post('user-billing/change', data)
         .then((response) => {
           if (response && response.status === 200) {
             success(context, response);
           }
         }).catch((error) => {
           failed(error, context);
         });



// WEBPACK FOOTER //
// ./src/app/services/user-billing/changeCard.js